import { API_URL } from "../config/api";

export const NOTIFICATIONS_CHANGED_EVENT = "vocabularium:notifications-changed";

export function dispatchNotificationsChanged() {
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_CHANGED_EVENT));
}

export async function fetchNotificationBadges() {
  const res = await fetch(`${API_URL}/notifications/badges`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Impossible de charger les notifications.");
  }
  return {
    medalsUnread: data.medalsUnread ?? 0,
    packsUnread: data.packsUnread ?? 0,
    packsPendingAssignment: data.packsPendingAssignment ?? 0,
    packsAlert: Boolean(data.packsAlert),
    historyUnread: data.historyUnread ?? 0,
    cloverRewardsUnread: data.cloverRewardsUnread ?? 0,
  };
}

export async function fetchLevelHistory() {
  const res = await fetch(`${API_URL}/mastery/level-history`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Impossible de charger l'historique.");
  }
  return {
    entries: Array.isArray(data.entries) ? data.entries : [],
    unreadCount: data.unreadCount ?? 0,
    packsUnread: data.packsUnread ?? 0,
  };
}

export async function markLevelHistoryAsRead() {
  const res = await fetch(`${API_URL}/mastery/level-history/read`, {
    method: "POST",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Impossible de marquer l'historique comme consulté.");
  }
  dispatchNotificationsChanged();
  return {
    entries: Array.isArray(data.entries) ? data.entries : [],
    unreadCount: data.unreadCount ?? 0,
    packsUnread: data.packsUnread ?? 0,
  };
}

export async function markPacksCaptureHistoryAsRead() {
  const res = await fetch(`${API_URL}/mastery/level-history/packs-read`, {
    method: "POST",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Impossible de marquer les captures comme consultées.");
  }
  dispatchNotificationsChanged();
  return {
    packsUnread: data.packsUnread ?? 0,
    unreadCount: data.unreadCount ?? 0,
  };
}

export async function markCloverRewardsAsRead() {
  const res = await fetch(`${API_URL}/notifications/clover-rewards-read`, {
    method: "POST",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(
      data.message || "Impossible de marquer les potions de trèfles comme consultées."
    );
  }
  dispatchNotificationsChanged();
  return {
    cloverRewardsUnread: data.cloverRewardsUnread ?? 0,
  };
}

export async function recordDailyQuestCompleteHistory(questDate) {
  const res = await fetch(`${API_URL}/mastery/level-history/daily-quest`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ questDate }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(
      data.message || "Impossible d'enregistrer la quête journalière dans l'historique."
    );
  }
  dispatchNotificationsChanged();
  return data;
}
